import {LOAD_TAX_BANDS_SUCCESS} from "../../../../actions/types";

const INITIAL_STATE = [];

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case LOAD_TAX_BANDS_SUCCESS:
            return action.payload;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/restaurants/settings/restaurant/TaxBandsReducer.js